const AdvancedTrainingBookSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31" fill="none">
      <g clipPath="url(#clip0_5350_68254)">
        <path
          d="M8.2665 6.71707V4.65045C8.2665 4.36512 8.03517 4.13379 7.74985 4.13379H0.516656C0.231335 4.13379 0 4.36512 0 4.65045V6.71707H8.2665Z"
          fill="#5D6977"
        />
        <path
          d="M0 7.75043V24.8001H8.2665V7.75043H0ZM6.19988 14.467H2.06663C1.7813 14.467 1.54997 14.2356 1.54997 13.9503V9.81705C1.54997 9.53173 1.7813 9.3004 2.06663 9.3004H6.19988C6.4852 9.3004 6.71653 9.53173 6.71653 9.81705V13.9503C6.71653 14.2356 6.4852 14.467 6.19988 14.467Z"
          fill="#5D6977"
        />
        <path
          d="M0 27.9V30.4833C0 30.7686 0.231335 31 0.516656 31H7.74985C8.03517 31 8.2665 30.7686 8.2665 30.4833V27.9H0Z"
          fill="#5D6977"
        />
        <path d="M0 25.8334H8.2665V26.8667H0V25.8334Z" fill="#5D6977" />
        <path d="M9.2998 25.8334H16.0163V26.8667H9.2998V25.8334Z" fill="#5D6977" />
        <path
          d="M16.0163 2.06717V0.517206C16.0163 0.231884 15.785 0.000549316 15.4997 0.000549316H9.81646C9.53114 0.000549316 9.2998 0.231884 9.2998 0.517206V2.06717H16.0163Z"
          fill="#5D6977"
        />
        <path d="M9.2998 5.68378H16.0163V24.8001H9.2998V5.68378Z" fill="#5D6977" />
        <path
          d="M9.2998 27.9V30.4833C9.2998 30.7686 9.53114 31 9.81646 31H15.4997C15.785 31 16.0163 30.7686 16.0163 30.4833V27.9H9.2998Z"
          fill="#5D6977"
        />
        <path d="M9.2998 3.10052H16.0163V4.65049H9.2998V3.10052Z" fill="#5D6977" />
        <path d="M17.0371 10.6995L17.3136 11.7608L26.0635 9.42753L25.7867 8.36621L17.0371 10.6995Z" fill="#5D6977" />
        <path d="M21.3553 27.2506L30.1049 24.9173L29.5509 22.7935L20.8008 25.1267L21.3553 27.2506Z" fill="#5D6977" />
        <path d="M29.2893 21.7937L26.3243 10.4273L17.5742 12.7606L20.5392 24.127L29.2893 21.7937Z" fill="#5D6977" />
        <path
          d="M16.7765 9.69975L25.5258 7.36673L24.7842 4.52133C24.7077 4.24585 24.4262 4.08112 24.1487 4.14948L16.3988 6.21611C16.1251 6.29103 15.9619 6.57131 16.0318 6.84629L16.7765 9.69975Z"
          fill="#5D6977"
        />
        <path
          d="M30.3653 25.9171L21.6152 28.2504L22.2315 30.6124C22.2674 30.7456 22.3546 30.8592 22.4745 30.9278C22.5524 30.9749 22.6417 30.9999 22.7328 30.9999C22.778 30.9999 22.8231 30.9946 22.867 30.9845L30.6169 28.9179C30.8906 28.843 31.0538 28.5625 30.9839 28.2875L30.3653 25.9171Z"
          fill="#5D6977"
        />
      </g>
      <defs>
        <clipPath id="clip0_5350_68254">
          <rect width="31" height="31" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AdvancedTrainingBookSvg;
